import React from "react";
import { Button } from "../ui/button";
import { Plus } from "lucide-react";

export function PageHeader({ title, description, actionLabel, onAction, action, children }) {
  return (
    <div className="flex items-start justify-between p-6 pb-0">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        {description && <p className="text-sm text-slate-500 mt-1">{description}</p>}
      </div>
      <div className="flex items-center gap-2">
        {children}
        {action}
        {actionLabel && onAction && (
          <Button onClick={onAction} data-testid="page-action">
            <Plus className="h-4 w-4 mr-2" />{actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
